import { render } from "./App.vue?vue&type=template&id=5f99223f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f99223f&lang=css"

import exportComponent from "D:\\Clouds\\Programacion\\Vue\\words-search\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__